import { render, staticRenderFns } from "./useCoupon.vue?vue&type=template&id=01c187b4&scoped=true"
import script from "./useCoupon.vue?vue&type=script&lang=js"
export * from "./useCoupon.vue?vue&type=script&lang=js"
import style0 from "./useCoupon.vue?vue&type=style&index=0&id=01c187b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c187b4",
  null
  
)

export default component.exports